import MsgBar from '../../atoms/MessageBar';
import ParentIDSearchBar from '../../atoms/ParentIDSearchBar';
import useSearchChildByParentID from '../../../hooks/searchChildByParentID.hook';
import OtpTextField from '../../atoms/OtpTextField';
import { useState } from 'react';

// Updated to search by mobile number instead
const SearchChildByParentID = ({ searchInfoSetter, label }) => {
  const [mainLabel, setMainLabel] = useState(label);
  const { searchParentById, setOtp, msg, showOtpField, isLoading } =
    useSearchChildByParentID(searchInfoSetter, setMainLabel);

  return (
    <div>
      <p className='my-5'>
        <MsgBar msg={mainLabel} type='normal' testid='label-msg' />
      </p>

      {showOtpField ? (
        <OtpTextField otpSetter={setOtp} />
      ) : (
        <ParentIDSearchBar parentIdSetter={searchParentById} />
      )}

      <div className='mt-4'>
        {isLoading ? <div className=''>One moment please...</div> : ''}
        <MsgBar msg={msg} testid='status-msg' />
      </div>
    </div>
  );
};

export default SearchChildByParentID;
